import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, of, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TransactionFormActions } from '../../../create-request/actions';
import { TransactionForm } from '../../../create-request/models/form/TransactionForm';
import { selectTransactionForm, selectTransactionType } from '../../../create-request/reducers';
import { transactionTypes } from '../../utilities/Constants';


@Component({
  standalone: false,
  selector: 'mm-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {
  @Input() showModal: Observable<string>;
  destroy$: Subject<boolean> = new Subject<boolean>();
  modal: EverestModal;
  title: string;
  transactionType: string;
  transactionForm: TransactionForm;

  constructor(private store: Store) { }

  ngOnInit(): void {
    this.modal = document.getElementById('overdraft-override-confirmation-modal') as EverestModal;
    this.showModal?.pipe(takeUntil(this.destroy$)).subscribe((err) => {
      if (err) {
        this.title = err;
        this.modal.showModal();
      };
    });

    this.store
      .select(selectTransactionType)
      .pipe(takeUntil(this.destroy$))
      .subscribe((type) => {
        this.transactionType = type;
      });

    this.store
      .select(selectTransactionForm)
      .pipe(takeUntil(this.destroy$))
      .subscribe((form) => {
        this.transactionForm = form;
      });
  }

  onCancelClick(): void {
    this.modal.hideModal();
  }

  onConfirmClick(): void {
    if (this.transactionType === transactionTypes.internalTransfer) {
      this.store.dispatch(TransactionFormActions.callInternalTransferVerify({ transactionForm: this.transactionForm, isInRViewReviewFlow: false }));
    }
    if (this.transactionType === transactionTypes.ach) {
      this.store.dispatch(TransactionFormActions.callAchVerify(this.transactionForm));
    }
    if (this.transactionType === transactionTypes.wire) {
      this.store.dispatch(TransactionFormActions.callWiresVerifyV3(this.transactionForm));
    }
    if (this.transactionType === transactionTypes.check) {
      this.store.dispatch(TransactionFormActions.callOnetimeCheckVerify(this.transactionForm));
    }
    this.modal.hideModal();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}

type EverestModal = HTMLElement & {
  showModal: () => {},
  hideModal: () => {}
};

